import { useHistory } from 'react-router-dom'
import soundFormattingService from 'app/services/utils/sound-formating.service'
import routesConstants from 'app/constants/routes.constants'
import { soundKeys, SOUNDS_TYPE } from 'app/constants/sounds.constants'
import { useAppSelector } from 'app/store'
import { Sound } from 'app/components/sounds/types/sound'

export default function useSound(
  soundId: number,
  soundCategory: SOUNDS_TYPE
): Sound | null {
  const soundKey = soundKeys[soundCategory]
  const sounds = useAppSelector((state) => state.sounds[soundKey].data.items)
  const history = useHistory()
  const [desiredSound] = sounds.filter((sound) => sound.id === soundId)
  let soundUrls

  if (desiredSound) {
    soundUrls = {
      audioSources: [
        {
          src: soundFormattingService.getSoundAudioURL(
            desiredSound.soundurl,
            soundCategory
          ),
          type: 'audio/mp3',
        },
      ],
      soundVideoPoster: soundFormattingService.getSoundVideoPosterURL(
        desiredSound.videourl
      ),
      videosSrc: soundFormattingService.getVideoSources(
        desiredSound.videourl,
        soundCategory
      ),

      songsSrc: soundFormattingService.getSongsSrc(desiredSound.songvideo),

      songPoster: soundFormattingService.getSongPoster(desiredSound.songvideo),

      quality: {
        default: 720,
        options: [360, 720, 1080],
      },
    }
  }
  if (sounds.length && !desiredSound) {
    if (soundCategory === SOUNDS_TYPE.SOUNDS) {
      history.push(routesConstants.SOUNDS)
    } else {
      history.push(routesConstants.SONIDOS)
    }
    window.location.href = '/hub/404'
  }

  return desiredSound && soundUrls ? { ...desiredSound, ...soundUrls } : null
}
